module.exports = __webpack_public_path__ + "static/media/success(2).ce2a0461.png";